import local from "./local";
import staging from "./staging";
import pro from "./pro";

export interface Config {
    API_SERVER_URL: string;
    STRIPE_DASHBOARD_URL: string;
    WEB_SIGNUP_LINK: string;
    FIREBASE_APP?: Record<string, string>;
    SUPPORT_CHAT_LINK?: string;
}

const configs: Record<string, Config> = { local, staging, pro };

const env = process.env.REACT_APP_ENV || "local";

export const config = configs[env];
